/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import { useParseHtmlContent } from "..";

import "../../../../../components/RichTextField/styles/customReactQuillNewStyle.css";

import { colors } from "@dotnet/telematics-design-system";

import { useDateTime } from "../../../../../shared";
import { useStyles } from "../styles";
import { NewsDto } from "../types";

interface NewsDialogTextContentProps {
  newsData: NewsDto | null;
  toMd: boolean;
}

const NewsDialogTextContent = ({
  newsData,
  toMd
}: NewsDialogTextContentProps) => {
  const { formatDateToEnString } = useDateTime();
  const { newsDialogTextContent } = useStyles({ toMd });
  const { parseContent } = useParseHtmlContent();

  const notesWithSpaces =
    newsData?.content
      .replaceAll("&nbsp;", " ")
      .replaceAll("<p></p>", "<p><br/></p>") ?? "";

  return (
    <div
      css={css(newsDialogTextContent)}
      data-testid="news-dialog-text-content"
    >
      <Typography
        variant="body3Medium"
        component="div"
        color={colors.textPlaceholder}
      >
        {formatDateToEnString(newsData?.createdAt)}
      </Typography>
      {newsData?.content && (
        <Typography
          variant="body2Regular"
          component="div"
          className="ql-editor"
          color={colors.textSecondary}
          sx={{
            height: "auto !important",
            'li[data-list="bullet"]': { listStyleType: "disc" },
            li: {
              listStyleType: "inherit"
            },
            ul: {
              paddingLeft: "1.5em"
            }
          }}
        >
          {parseContent(notesWithSpaces)}
        </Typography>
      )}
      <div css={css({ height: "16px" })} />
    </div>
  );
};

export default NewsDialogTextContent;
